// extracted by mini-css-extract-plugin
export default {"accounting":"style_accounting__f6Lk4"};